import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import md5 from 'md5'

import { createPlainTextMessage } from '../../api'
import socket from '../../socket'
import config from '../../config'

const Container = styled.div`
  border-top: 1px solid #f3f3f3;
  padding-left: 16px;
  display: flex;
`

const Form = styled.form`
  flex: 1;
  display: flex;
  align-items: center;
`

const Input = styled.input`
  font-family: 'Open Sans', sans-serif;
  font-size: 1em;
  border: none;
  padding: 0 16px;
  flex: 1;
  width: 100%;

 :focus {
    outline: none;
  }
`

const Button = styled.button`
  font-family: 'Open Sans', sans-serif;
  font-size: 1em;
  margin-left: 16px;
  padding: 16px;
  border: transparent;
  background-color: transparent;
  color: ${props => props.body.length > 0 ? '#48b1bf' : '#9b9b9b'};
  opacity: ${props => props.sending ? 0.5 : 1.0};

 :focus {
    outline: none;
  }
`

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-size: 32px 32px;
  float: left;
  margin-top: 4px;
`

class ChatInput extends Component {
  state = {
    sending: false,
    body: ''
  }

  handleChangeText = ({ target: { value } }) => {
    const { conversationId, userId } = this.props
    const trimmedBody = (value || '').trim()
    socket.emit('typing', { charactersCount: trimmedBody.length, userId, conversationId })
    this.setState({ body: value })
  }

  handleSendPress = async event => {
    event.preventDefault()

    let { body } = this.state
    if (body.length === 0) return

    const { conversationId, userId, onMessageCreated } = this.props
    socket.emit('typing', { charactersCount: 0, userId, conversationId })

    this.setState({ sending: true })
    await createPlainTextMessage({
      conversationId,
      userId,
      body
    })

    this.setState({ body: '', sending: false })

    onMessageCreated && onMessageCreated()
  }

  renderPictureUrl = ({ id, pictureUrl }) => {
    const imageUrl = pictureUrl
      // ? `https://${config.imgixHost}/${pictureUrl.substr(pictureUrl.lastIndexOf('/') + 1)}?w=32&h=32&fit=crop&mask=ellipse&dpr=2&fm=png32`
      ? `https://${config.cloudimageHost}/${pictureUrl.substr(pictureUrl.lastIndexOf('/') + 1)}?width=32&height=32&func=crop&optipress=1`
      : `${config.apiUrl}/avatar/${md5(id.trim().toLowerCase())}?s=64`

    return <Avatar style={{ backgroundImage: `url(${imageUrl})` }} />
  }

  render () {
    const { participant, t } = this.props
    const { body, sending } = this.state

    return (
      <Container>
        <Form>
          {participant.user && this.renderPictureUrl(participant.user)}
          <Input
            type='text'
            value={body}
            autoFocus
            required
            placeholder={t('conversation_input_placeholder')}
            onChange={this.handleChangeText} />
          <Button body={body} sending={sending} onClick={this.handleSendPress}><i className={sending ? "fa fa-circle-notch fa-spin" : "fas fa-paper-plane"}></i></Button>
        </Form>
      </Container>
    )
  }
}

const ChatInputContainer = createFragmentContainer(ChatInput, {
  participant: graphql`
    fragment ChatInput_participant on Participant {
      associationId
      associationType
      user: userByUserId {
        id
        firstName
        middleName
        lastName
        pictureUrl
      }
    }
  ` }
)

const TranslatedChatInput = withTranslation()(ChatInputContainer)
export { TranslatedChatInput as ChatInput }
